export const StatusIndicator = ({hasValue}: {hasValue: boolean}) => {
  return (
    <span
      className={
        hasValue
          ? 'inline-block w-2 h-2 bg-green-500 rounded-full ml-2'
          : 'inline-block w-2 h-2 bg-gray-300 rounded-full ml-2'
      }
    />
  );
};
